module.exports = Object.freeze({
    fetchConstants:{
        URL_SEPARATOR:'?',
        PARAM_SEPARATOR:'&',
        HTTP_GET_METHOD:'GET'
    }
})